<template>
  <div :class="`${el}__switcherRow`">
    <template v-if="show">
      <InViewAnimation :delay="2">
        <SwitcherRowUI
          slot="0"
          :head="{
            image: content.image,
            copy: content.headline,
          }"
          :body="{
            copy: content.bulletHead,
            list: content.bullets,
          }"
          :switcher="{
            copy: content.switchHeadline,
          }"
          :radioGroupHeadline="content.radioGroupHeadline"
          :radioGroup="[
            {
              headline: content.bottomBoxSupport.headline[0],
              visible: checked,
              slotName: 'bottomBoxSupport',
            },
            {
              headline: content.bottomBoxActivities.headline[0],
              visible: careService[id] && careService[id][0] !== null,
              slotName: 'bottomBoxActivities',
            },
          ]"
        >
          <ToggleSwitch
            slot="ToggleSwitch"
            :activeLabel="content.switchBtn.activeLabel"
            :id="content.switchBtn.id"
            :inactiveLabel="content.switchBtn.inactiveLabel"
            :checked="checked"
            @click="onChangeToggleSwitch"
          />
          <Radiogroup
            slot="bottomBoxSupport"
            :direction="$matchMedia.l ? 'horizontal' : 'vertical'"
          >
            <Radiobutton
              v-for="(item, i) in content.bottomBoxSupport.items"
              :slot="i"
              :key="`bbs-radiobutton-${i}`"
              :id="`bbs-radiobutton-${item.id}${i}`"
              :name="`bbs-radiobutton-${i}`"
              :label="item.label"
              :checked="careService[id] && careService[id][0] === i"
              @input="dispatch(0, i)"
            />
          </Radiogroup>
          <Radiogroup
            slot="bottomBoxActivities"
            :direction="$matchMedia.l ? 'horizontal' : 'vertical'"
          >
            <Radiobutton
              v-for="(item, i) in content.bottomBoxActivities.items"
              :slot="i"
              :key="`bba-radiobutton-${i}`"
              :id="`bba-radiobutton-${item.id}${i}`"
              :name="`bba-radiobutton-${i}`"
              :label="item.label"
              :checked="careService[id] && careService[id][1] === i"
              @input="dispatch(1, i)"
            />
          </Radiogroup>
        </SwitcherRowUI>
      </InViewAnimation>
    </template>
  </div>
</template>

<script>
import ToggleSwitch from '@/objects/ToggleSwitch';
import Radiogroup from '@/objects/Forms/BaseRadioGroup';
import Radiobutton from '@/objects/Forms/BaseRadio';
import SwitcherRowUI from '@/components/SwitcherRow';
import InViewAnimation from '@/components/InViewAnimation';

import { mapFieldsCareService } from '@/store/mapFields';
import { CARESERVICE_ADD_STEP, CARESERVICE_REMOVE_STEP } from '@/store/actions/careService';

export default {
  name: 'SwitcherRow',
  props: {
    content: Object,
    id: String,
    el: String,
  },
  components: {
    ToggleSwitch,
    SwitcherRowUI,
    InViewAnimation,
    Radiogroup,
    Radiobutton,
  },
  computed: {
    ...mapFieldsCareService(['careService', 'careServiceStepIsValid']),
  },
  data() {
    return {
      show: true,
      checked: false,
    };
  },
  mounted() {
    this.careServiceStepIsValid = true;
    this.checked =
      this.careService[this.id] && this.careService[this.id].filter((i) => i !== null).length === 2;
  },
  watch: {
    id() {
      this.careServiceStepIsValid = true;
      this.checked =
        this.careService[this.id] &&
        this.careService[this.id].filter((i) => i !== null).length === 2;

      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 1);
    },
  },
  methods: {
    onChangeToggleSwitch() {
      this.checked = !this.checked;

      if (this.checked) {
        this.$store.dispatch(CARESERVICE_ADD_STEP, { id: this.id, arr: [null, null] });
      } else {
        this.$store.dispatch(CARESERVICE_REMOVE_STEP, { id: this.id });
      }

      this.careServiceStepIsValid = !this.checked;
    },

    dispatch(idx1, idx2) {
      const arr = this.careService[this.id];
      arr[idx1] = idx2;
      this.$store.dispatch(CARESERVICE_ADD_STEP, {
        id: this.id,
        arr,
      });

      this.isValid();
    },

    isValid() {
      this.careServiceStepIsValid =
        this.careService[this.id].filter((i) => i === null).length === 0;
    },
  },
};
</script>
